import React, { Component } from 'react';
import { Button, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import { retailerAPI, getinsightcontent } from '../../API/FetchCall';
import { BASE_URL } from '../../constant';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const settings = {
  slidesToShow: 2,
  slidesToScroll: 1,
  dots: true,
  infinite: false,
  autoplay: true,
  centerMode: false,
  autoplaySpeed: 8000,
  dots: false,
  arrows: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
        slidesToScroll: 1
      }
    }
  ]
};
class RetailList extends Component {
  constructor(props) {
    console.log('+ props', props)
    super(props);
    this.state = {
      contentList: [],
      latitude: localStorage.getItem('latitude') ? localStorage.getItem('latitude') : '',
      longitude: localStorage.getItem('longitude') ? localStorage.getItem('longitude') : '',
      popoverOpen: []
    };
    this.topics();
  }


  componentDidMount() {
    let THIS = this;
    navigator.geolocation.getCurrentPosition(function (position) {
      console.log("+++++ Latitude is :", position.coords.latitude);
      console.log("+++++ Longitude is :", position.coords.longitude);
      THIS.setState({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      });
      THIS.topics(position.coords.latitude, position.coords.longitude);
    });
  }
  topics = async (latitude, longitude) => {

    let req = JSON.stringify({
      role: 4,
      category: 1,
      latitude: latitude ? latitude : this.state.latitude,
      longitude: longitude ? longitude : this.state.longitude,
      category: this.props.retail.category_id,
      subcategory_name: this.props.retail.subcategory_name,
      second_subcategory_name: this.props.retail.second_subcategory_name,
      location: this.props.retail.location,
      url: 'get_list_user'
    })
    const response = await retailerAPI(req);
    if (response.status === 1) {
      this.setState({ contentList: response.data });
    }
  };
  onHover = (e, i) => {
    let popoverOpen = this.state.popoverOpen;
    popoverOpen[i] = !popoverOpen[i];
    console.log('popoverOpen', popoverOpen)
    this.setState({
      popoverOpen: popoverOpen
    })
  }

  onHoverLeave = (e, i) => {
    let popoverOpen = this.state.popoverOpen;
    popoverOpen[i] = !popoverOpen[i];
    this.setState({
      popoverOpen: popoverOpen
    })
  }
  render() {
    return (
      <React.Fragment>
        <div id="retailerinfo_section" className=''>
          {this.state.contentList.length == 0 && (
            <div>
              <h3>Retailers</h3>
              <div class="noneblock">
                None
              </div>
            </div>
          )}
          {this.state.contentList.length > 0 && (
            <div>
              <h3>Retailers</h3>
              <div>
                <div className="col-12 p-0">
                  <Slider ref={c => (this.slider = c)}  {...settings} >
                    {this.state.contentList.map((content, inx) => {
                      return (
                        <React.Fragment>
                          <div className="campbox retailerBox"
                          // onClick={(e) => this.onHover(e, inx)}
                          // onMouseEnter={this.onHover}
                          // onMouseLeave={this.onHoverLeave}
                          >
                            <div className="blogDet">
                              <div className='row'>
                                <div className='col-md-12'>
                                  <h5 className={this.state.popoverOpen[inx] ? '' : 'text-wrap'}
                                    title={content.retailer_name}>{content.retailer_name}</h5>
                                </div>
                              </div>
                              <div className='row retail-content mt-2'>
                                <div className='col-md-12'>
                                  <label>Address</label>
                                  <p className={this.state.popoverOpen[inx] ? '' : 'add-sec'}>{content.address ? content.address : 'NA'}</p>
                                </div>
                                <div className='col-md-12'>
                                  <label>Timing</label>
                                  <p>{content.time ? content.time : 'NA'}</p>
                                </div>
                                <div className='' style={{ display: this.state.popoverOpen[inx] ? 'block' : 'none' }}>
                                  <div className='col-md-12'>
                                    <label>Contact</label>
                                    <p className={''}>
                                      {content.contact_person || content.mobile_number ?
                                        (`${content.contact_person} ${content.mobile_number}`)
                                        :
                                        ('NA')
                                      }
                                    </p>
                                  </div>
                                  <div className='col-md-12'>
                                    <label>Email</label>
                                    <p className={''}>
                                      {content.email_id ? content.email_id : 'NA'}</p>
                                  </div>

                                  <div className='col-md-12'>
                                    <label>About</label>
                                    <p>{content.about ? content.about : 'NA'}</p>
                                  </div>
                                </div>
                                <div className='col-md-12'>
                                  <span className='pointer pull-right' onClick={(e) => this.onHover(e, inx)}>
                                    <b>{this.state.popoverOpen[inx] ? 'See Less' : 'See More'}</b>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </React.Fragment>
                      )
                    })
                    }
                  </Slider>
                </div>
              </div>
            </div>
          )}
        </div>
      </React.Fragment >
    );
  }
}
export { RetailList };
